


import React, { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { useLanguage } from "../i18n/LanguageProvider";
import {
  addUidScopedValue,
  createUidScopedState,
  getUidScopedValues,
  persistUidScopedState,
  switchUidScopedState,
} from "../utils/uidScopedLocalStorage";




export default function VouchersPage({ currentUid }) {
  const { t } = useLanguage();
  const [vouchers, setVouchers] = useState([]);
  const [copiedId, setCopiedId] = useState(null);
  const [hiddenVoucherState, setHiddenVoucherState] = useState(() =>
    createUidScopedState(localStorage, "vq_hidden_vouchers", currentUid)
  );
  const hiddenVoucherIds = getUidScopedValues(hiddenVoucherState, currentUid);


  useEffect(() => {
  if (!currentUid) {
    setVouchers([]);
    return;
  }

  const q = query(
    collection(db, "voucherCodes"),
    where("assignedTo", "==", currentUid)
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const items = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

items.sort((a, b) => {
  const aTime = a.assignedAt?.seconds || 0;
  const bTime = b.assignedAt?.seconds || 0;
  return bTime - aTime;
});

    setVouchers(items);
  });

  return () => unsubscribe();
}, [currentUid]);


useEffect(() => {
  setHiddenVoucherState((currentState) =>
    switchUidScopedState(currentState, localStorage, "vq_hidden_vouchers", currentUid)
  );
}, [currentUid]);

useEffect(() => {
  try {
    persistUidScopedState(
      hiddenVoucherState,
      localStorage,
      "vq_hidden_vouchers",
      currentUid
    );
  } catch (error) {
    console.error("Failed to save hidden vouchers:", error?.code || error?.message || "unknown");
  }
}, [currentUid, hiddenVoucherState]);




const handleCopyCode = async (voucher) => {
  const code = voucher?.code || "";
  if (!code) return;

  try {
    await navigator.clipboard.writeText(code);
    setCopiedId(voucher.id);

    setTimeout(() => {
      setCopiedId((current) => (current === voucher.id ? null : current));
    }, 2000);
  } catch (error) {
    console.error("Copy failed:", error?.code || error?.message || "unknown");
  }
};

const handleHideVoucher = (voucherId) => {
  setHiddenVoucherState((currentState) =>
    addUidScopedValue(
      currentState,
      localStorage,
      "vq_hidden_vouchers",
      currentUid,
      voucherId
    )
  );
};



const getProviderLabel = (provider) => {
  switch (String(provider || "").toLowerCase()) {
    case "amazon":
      return "Amazon";
    case "zalando":
      return "Zalando";
    case "media_markt":
      return "MediaMarkt";
    case "saturn":
      return "Saturn";
    case "psn":
      return "PlayStation";
    case "xbox":
      return "Xbox";
    case "steam":
      return "Steam";
    case "nintendo":
      return "Nintendo";
    default:
      return provider || t("vouchers.unknownProvider");
  }
};



// Richtiger Return
  return (
  <div
    style={{
      width: "92%",
      margin: "18px auto 0 auto",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
    }}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
      }}
    >
      {vouchers.filter((voucher) => !hiddenVoucherIds.includes(voucher.id)).length === 0 ? (
        <div
          style={{
            background: "rgba(255,255,255,0.05)",
            border: "1px solid rgba(255,255,255,0.10)",
            borderRadius: "20px",
            padding: "18px 16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.22)",
            color: "rgba(255,255,255,0.9)",
            fontSize: "15px",
            lineHeight: "1.5",
          }}
        >
          {t("vouchers.empty")}
        </div>
      ) : (
        vouchers
          .filter((voucher) => !hiddenVoucherIds.includes(voucher.id))
          .map((voucher) => (
            <div
              key={voucher.id}
              style={{
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.10)",
                borderRadius: "20px",
                padding: "22px 18px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.22)",
              }}
            >
             <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "18px",
  }}
>
  <div style={{ minWidth: 0 }}>
    <div
      style={{
        fontSize: "17px",
        fontWeight: "700",
        color: "rgba(255,255,255,0.72)",
        marginBottom: "6px",
        textTransform: "uppercase",
        letterSpacing: "0.4px",
      }}
    >
      {t("vouchers.providerLabel")}
    </div>

    <div
      style={{
        fontSize: "24px",
        fontWeight: "800",
        color: "#fff",
        lineHeight: "1.2",
      }}
    >
      {getProviderLabel(voucher.provider)}
    </div>
  </div>

  <div
    style={{
      flexShrink: 0,
      textAlign: "right",
      color: "rgba(255,255,255,0.60)",
      fontSize: "13px",
      lineHeight: "1.4",
    }}
  >
    <div>{t("vouchers.receivedAtLabel")}</div>
    <div style={{ color: "rgba(255,255,255,0.82)", marginTop: "2px" }}>
      {voucher.assignedAt?.toDate
        ? voucher.assignedAt.toDate().toLocaleDateString()
        : "-"}
    </div>
  </div>
</div>

              <div
                style={{
                  fontSize: "17px",
                  fontWeight: "700",
                  color: "rgba(255,255,255,0.72)",
                  marginBottom: "6px",
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                }}
              >
                {t("vouchers.valueLabel")}
              </div>

              <div
                style={{
                  color: "#fff",
                  fontSize: "30px",
                  fontWeight: "800",
                  marginBottom: "20px",
                  lineHeight: "1.1",
                }}
              >
                {voucher.value ? `${voucher.value} €` : "-"}
              </div>

              <div
                style={{
                  fontSize: "17px",
                  fontWeight: "700",
                  color: "rgba(255,255,255,0.72)",
                  marginBottom: "8px",
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                }}
              >
                {t("vouchers.codeLabel")}
              </div>

              <div
                style={{
                  color: "#fff",
                  fontSize: "18px",
                  fontWeight: "800",
                  wordBreak: "break-word",
                  lineHeight: "1.4",
                  marginBottom: "22px",
                }}
              >
                {voucher.code || "-"}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "14px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  type="button"
                  onClick={() => handleCopyCode(voucher)}
                  style={{
                    borderRadius: "14px",
                    padding: "12px 18px",
                    fontWeight: "800",
                    fontSize: "14px",
                    cursor: "pointer",
                    background:
                      copiedId === voucher.id
                        ? "rgba(255,255,255,0.12)"
                        : "linear-gradient(90deg, rgba(255,0,170,0.95) 0%, rgba(160,60,255,0.95) 100%)",
                    color: "#fff",
                    boxShadow:
                      copiedId === voucher.id
                        ? "none"
                        : "0 8px 22px rgba(0,0,0,0.22)",
                    border:
                      copiedId === voucher.id
                        ? "1px solid rgba(255,255,255,0.16)"
                        : "none",
                  }}
                >
                  {copiedId === voucher.id
                    ? `✓ ${t("vouchers.copied")}`
                    : t("vouchers.copyCode")}
                </button>

                <button
                  type="button"
                  onClick={() => handleHideVoucher(voucher.id)}
                  style={{
                    border: "1px solid rgba(255,255,255,0.16)",
                    borderRadius: "14px",
                    padding: "12px 18px",
                    fontWeight: "700",
                    fontSize: "14px",
                    cursor: "pointer",
                    background: "rgba(255,255,255,0.04)",
                    color: "#fff",
                  }}
                >
                  {t("vouchers.remove")}
                </button>
              </div>
            </div>
          ))
      )}
    </div>
  </div>
);
}
